<template>
  <div id="OutClinicInvoice" class="print-content">
    <div class="d-flex justify-content-center w-100">
      <h1
        style="font-size: 50px; font-weight: 800; color: #0056b3"
        class="w-100 d-flex justify-content-center align-items-center flex-column"
      >
        <div>مستشفى الوزيرية</div>
        <div>بغداد</div>
      </h1>
    </div>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <span
        class="mt-2"
        style="
          margin-top: 30px;
          color: #0056b3;
          font-size: 30px;
          font-weight: 600;
        "
      >
        N : {{ data.invoice_no }}
      </span>
      <!-- <div style="align-items: center; display: flex; flex-direction: column">
        <div class="d-flex align-items-center">
          <div class="d-flex flex-column pt-1">
            <span style="font-size: 28px; font-weight: 600; color: #0056b3">
              42531691
            </span>
            <span style="font-size: 28px; font-weight: 600; color: #0056b3">
              42531671
            </span>
          </div>
          <span
            class="mx-2"
            style="font-size: 73px; font-weight: 100; color: #0056b3"
          >
            {{ "{" }}
          </span>
          <h2
            style="
              font-size: 36px;
              font-weight: 600;
              color: #0056b3;
              align-items: center;
              display: flex;
              justify-content: center;
              flex-direction: column;
              height: 100%;
            "
          >
            بدالة ذات خطين
          </h2>
        </div>
      </div> -->
      <div style="display: flex; align-items: center; margin-top: 5px">
        <div
          style="
            border-bottom: 2px dashed #0056b3;
            flex-grow: 1;
            margin: 0 10px;
            width: 100%;
          "
        >
          <span
            class="d-flex justify-content-center"
            style="
              font-size: 25px;
              text-align: center;
              font-weight: 600;
              color: #0056b3;
            "
            >{{ date }}</span
          >
        </div>
        <div
          style="
            font-size: 30px;
            font-weight: 600;
            text-align: right;
            flex-grow: 1;
            width: 150px !important;
            color: #0056b3;
          "
        >
          : التاريخ
        </div>
      </div>
    </div>
    <div style="display: flex; align-items: center; margin-top: 5px">
      <div
        style="
          border-bottom: 2px dashed #0056b3;
          flex-grow: 1;
          margin: 0 10px;
          width: 100%;
          margin-left: 600px !important;
        "
      >
        <span
          class="d-flex justify-content-center"
          style="
            font-size: 25px;
            text-align: center;
            font-weight: 600;
            color: #0056b3;
          "
          >{{ $store.state.auth.userInfo.name }}</span
        >
      </div>
      <div
        style="
          font-size: 30px;
          font-weight: 600;
          text-align: right;
          flex-grow: 1;
          width: 150px !important;
          color: #0056b3;
          text-wrap: nowrap;
          margin-left: 25px !important;
          margin-right: 3px !important;
        "
      >
        : اسم المستخدم
      </div>
    </div>
    <div
      class="mt-8 d-flex justify-content-center"
      style="
        margin-top: 10px !important;
        color: #0056b3;
        font-size: 40;
        text-decoration: underline;
      "
    >
      <span
        style="
          margin-top: 10px;
          color: #0056b3;
          font-size: 40px;
          font-weight: 600;
          text-decoration: underline;
          margin-bottom: 10px;
        "
      >
        العيادة الخارجية</span
      >
    </div>

    <div style="margin-top: 10px; color: #0056b3">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div
          style="
            border-bottom: 2px dashed #0056b3;
            flex-grow: 1;
            margin: 0 10px;
            width: 100%;
          "
        >
          <span
            class="d-flex justify-content-center"
            style="
              font-size: 30px;
              text-align: center;
              font-weight: 600;
              color: #0056b3;
            "
          >
            <span v-if="data.patient_card">
              {{ data.patient_card.patient.name }}
            </span>
            <span v-else>
              {{ patientData.name }}
            </span>
          </span>
        </div>
        <div style="font-size: 30px; font-weight: 600">:الاسم</div>
      </div>
      <div
        style="
          display: flex;

          align-items: center;
          margin-top: 5px;
        "
      >
        <div
          style="
            border-bottom: 2px dashed #0056b3;
            flex-grow: 1;
            margin: 0 10px;
            width: 100%;
          "
        >
          <span
            class="d-flex justify-content-center"
            style="
              font-size: 30px;
              text-align: center;
              font-weight: 600;
              color: #0056b3;
            "
            >{{ data.amount }}</span
          >
        </div>
        <div
          style="
            font-size: 30px;
            font-weight: 600;
            text-align: right;
            flex-grow: 1;
            width: 30%;
          "
        >
          :مبلغا و قدره
        </div>
      </div>

      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 30px;
          margin-bottom: 30px;
        "
      >
        <div
          style="
            border-bottom: 2px dashed #0056b3;
            flex-grow: 1;
            margin: 0 10px;
          "
        >
          <span
            class="d-flex justify-content-center"
            v-if="data.service"
            style="
              font-size: 30px;
              text-align: center;
              font-weight: 600;
              color: #0056b3;
            "
            >{{ data.service.title }}</span
          >
        </div>
        <!-- <div
          style="
            border-bottom: 1px dashed #0056b3;
            flex-grow: 1;
            margin: 0 10px;
            font-size: 43px;
            text-align: center;
          "
        >
          <span v-if="data.service">
            {{ data.service.title }}
          </span>
        </div> -->
        <div style="font-size: 30px; font-weight: 600; color: #0056b3">
          : على حساب
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <span style="font-size: 25px; font-weight: 600; color: #0056b3">
          المستلم</span
        >
        <div style="display: flex; flex-direction: column; text-align: right">
          <span style="font-size: 20px; font-weight: 600; color: #0056b3">
            ممنوع اصطحاب الاطفال -
          </span>
          <span style="font-size: 20px; font-weight: 600; color: #0056b3">
            تنتهي الزيارة الساعة 9 مساءا -</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "patientData"],
  computed: {
    date() {
      return new Date().toLocaleDateString("en-IQ", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      });
    },
  },
  methods: {
    addDigits(number) {
      // Convert the number to a string
      let numberString = number.toString();

      // Check if the length is less than 5
      while (numberString.length < 5) {
        // Add a zero to the left
        numberString = "0" + numberString;
      }

      return numberString;
    },
   
  },
};
</script>
<style scoped>
.print-content {
  display: none;
}
.rtl {
  direction: rtl;
}
.ltr {
  direction: ltr;
}
/* Show the print content when printing */
@media print {
  .print-content {
    display: block;
  }
  button {
    display: none; /* Hide the button when printing */
  }
}
p.solid {
  border-style: solid;
}
table {
  background-color: #333;
  width: 60%;
  border-collapse: separate;
  border-spacing: 0;
  margin: 20px auto;
  border-radius: 10px;
  overflow: hidden;
  border: 3px solid #333;
}
th,
td {
  padding: 8px;
  text-align: center;
  border-bottom: 1px solid #333;
}
th {
  background-color: #f2f2f2;
}
tr:last-child td {
  border-bottom: none;
}
</style>
<!--  -->
